import React from 'react';
import { SpinnerLinear } from '.';
import { close_light_red } from '../../../assets/images';

const Progressbar = ({ classes = '', filename, percent, heading, close }) => {
  return (
    <div className={'bg-white border border-gray-300 p-3 rounded-ds-sm ' + classes}>
      <SpinnerLinear />
      <h1 className='text-gray-600 font-semibold text-ts-md mb-0 inline-block ml-2'>{heading}</h1>
      <div className='text-gray-400 font-semibold flex items-center mt-4 leading-none'>
        <span className='inline-block h-1 w-1 bg-gray-400 mr-1 rounded-ds-sm'></span>
        {filename}
      </div>

      <div className='bg-ds-brand-100 rounded-ds-sm mt-2 inline-block' style={{width:'97%'}}><div className='bg-ds-brand rounded-ds-sm' style={{ width: `${percent}%`, height: 6 }}></div></div>
      <img src={close_light_red} alt='close_icon' className='h-5 w-5 ml-3 inline-block cursor-pointer' onClick={close}/>
    </div>
  );
};

export default Progressbar;
